import { ErrorResponse } from 'react-router-dom';
import { IUseHttpServiceProps } from '../services/type';
import { RequestMethods } from '../services/enum';
import {
  IResponse,
  IExpiringPolicies,
  IOverview,
  IPolicyDistributions,
} from '../types';

export default class DashboardService {
  private readonly baseUrl = 'dashboard/dashboard/';

  constructor(
    private readonly executeService: <T>(
      args: IUseHttpServiceProps,
    ) => Promise<T | ErrorResponse | null>,
  ) {}

  async fetchExpiringPolicies(
    id: number,
  ): Promise<IResponse<IExpiringPolicies> | ErrorResponse | null> {
    return await this.executeService<IResponse<IExpiringPolicies>>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${id}/expiring-policies/`,
    });
  }

  async fetchOverview(id: number): Promise<IOverview[] | ErrorResponse | null> {
    return await this.executeService<IOverview[]>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${id}/overview?status=request_created&status=cancel_expected`,
    });
  }

  async fetchPolicyDistributions(
    id: number,
  ): Promise<IPolicyDistributions | ErrorResponse | null> {
    return await this.executeService<IPolicyDistributions>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${id}/policy-distributions/`,
    });
  }
}
